import isDark from '../../../../common/verifiers/is-dark';
import increaseColorPointByRatio from '../../../../common/utils/increase-color-point-by-ratio';
import reduceColorPointByRatio from '../../../../common/utils/reduce-color-point-by-ratio';

const primary = (params) => {
  const { backgroundColor, infoColorPalette: targetColorPalette } = params;

  const fallback = {
    rule: 'input.borderColor.focus.primary',
    params,
  };
  if (!isDark(backgroundColor)) {
    return increaseColorPointByRatio({
      targetColor: targetColorPalette[50],
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 2.3,
      fallback,
    });
  }

  return reduceColorPointByRatio({
    targetColor: targetColorPalette[900],
    backgroundColor,
    targetColorPalette,
    condition: (ratio) => ratio >= 3.7,
    fallback,
  });
};

export default primary;
